// extracted by mini-css-extract-plugin
export default {"main":"Profile_main__ruSfG","body":"Profile_body__NY+YZ"};